export default __webpack_public_path__ + "static/Poppins-Regular-35d26b781dc5fda684cce6ea04a41a75.ttf";